/* UAT affiliate click analytics V4: include Partnerize placement ref. No new cookies. */
(() => {
  'use strict';
  const lastClick = new WeakMap();
  function classify(link, url) {
    let path = url.pathname + url.search;
    try { path = decodeURIComponent(path); } catch (_) {}
    const explicit = (link.dataset.uatoProduct || '').toLowerCase();
    if (['tickets','short_break','scarefest','fireworks','annual_pass'].includes(explicit)) return explicit;
    const text = ((link.textContent || '') + ' ' + path).toLowerCase();
    if (/short.break|hotel|sleepover|overnight|accommodation/.test(text)) return 'short_break';
    if (/scarefest|halloween|maze/.test(text)) return 'scarefest';
    if (/firework/.test(text)) return 'fireworks';
    if (/annual.pass|merlin.pass/.test(text)) return 'annual_pass';
    return 'tickets';
  }
  function placement(link) {
    if (link.dataset.uatoPlacement) return link.dataset.uatoPlacement;
    const el = link.closest('header,footer,nav,aside,article,main,section');
    if (!el) return 'content';
    if ((el.id || '').toLowerCase().includes('hero')) return 'hero';
    return el.tagName.toLowerCase();
  }
  function trackAffiliateActivation(event) {
    // Record normal left/keyboard activation and the middle-click/new-tab path.
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.hostname !== 'prf.hn' && url.hostname !== 'merlin.prf.hn') return;
    if (/^\/(admin|traffic)(\/|$)/i.test(window.location.pathname)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    const now = Date.now();
    if (now - (lastClick.get(link) || 0) < 900) return;
    lastClick.set(link, now);
    const fields = {
      affiliate_network: 'partnerize',
      affiliate_interaction: event.type === 'auxclick' ? 'middle_click' : 'primary_click',
      affiliate_pubref: (decodeURIComponent((url.pathname.match(/(?:^|\/)pubref:([^/]+)/) || [,''])[1])).slice(0,80),
      affiliate_product: classify(link, url),
      affiliate_source: link.dataset.uatoSource || (window.location.pathname.indexOf('/blogs/') === 0 ? 'article' : 'site'),
      link_placement: placement(link),
      page_path: window.location.pathname,
      page_title: document.title.slice(0, 100),
      outbound_destination: 'partnerize',
      link_text: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100),
      transport_type: 'beacon'
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'affiliate_click', fields);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({event: 'affiliate_click'}, fields));
    }
  }
  document.addEventListener('click', trackAffiliateActivation, true);
  document.addEventListener('auxclick', trackAffiliateActivation, true);
})();
